import { render, staticRenderFns } from "./surveyList.vue?vue&type=template&id=48681cbf"
import script from "./surveyList.vue?vue&type=script&lang=js"
export * from "./surveyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports